export const USER_ROLES = {
  ADMIN: "Admin",
  TRAINER: "Trainer",
  STUDENT: "Student",
  ENTERPRISE: "Enterprise",
  ALL: "All"
};